// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2837) return "static/chunks/2837.6de477457beaa5db.js";
	if (chunkId === 7950) return "static/chunks/7950.dd695956b5a62a6d.js";
	if (chunkId === 4333) return "static/chunks/4333.d33c7952d0240c91.js";
	if (chunkId === 6099) return "static/chunks/6099.423d0f8a80f215e8.js";
	if (chunkId === 5063) return "static/chunks/5063.cab39769b06b67d0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1585":"986aae10a67adc95","1909":"57ee90bd86d274a2","2562":"921c548b64d1016f","2784":"4a295c932cd6e619","5283":"52408794b72159ef","7529":"ce781613e77e09ff","7606":"c96097480cac5277"}[chunkId] + ".js";
};